module.exports = __webpack_public_path__ + "img/1J7.fab04b3f.png";